/* Help: cards of prose beside a list of them. Tokens only (ADR-0007). */

.body {
  grid-column: 1 / -1;
  min-width: 0;
}

.topic {
  display: grid;
  grid-template-columns: minmax(0, 220px) minmax(0, 1fr);
  gap: var(--gap);
  align-items: start;
}

.toc {
  position: sticky;
  top: 0;
  padding: 12px 14px;
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  background: var(--panel);
}

.tocTitle {
  display: block;
  margin-bottom: 6px;
  font-size: var(--t-min);
  font-weight: 600;
  color: var(--muted);
}

.toc ul {
  display: grid;
  gap: 1px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.tocLink {
  width: 100%;
  padding: 4px 6px;
  border: 0;
  border-radius: var(--radius-ctl);
  background: none;
  font: inherit;
  font-size: var(--t-min);
  line-height: 1.4;
  text-align: left;
  color: var(--ink-2);
  cursor: pointer;
}

.tocLink:hover {
  background: var(--panel-2);
  color: var(--accent);
}

.tocLink:active {
  background: var(--panel-3);
}

.tocLink:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.sections {
  display: grid;
  gap: var(--gap);
  min-width: 0;
}

.card {
  min-width: 0;
  padding: 14px 18px 16px;
  border: 1px solid var(--line);
  border-radius: var(--radius-card);
  background: var(--panel);
  scroll-margin-top: 8px;
}

.heading {
  margin: 0 0 8px;
  font-size: var(--t-head);
  font-weight: 650;
  letter-spacing: -0.01em;
  color: var(--ink);
}

.text {
  max-width: 78ch;
  margin: 0 0 8px;
  font-size: var(--t-dense);
  line-height: 1.6;
  color: var(--ink-2);
}

.text:last-child {
  margin-bottom: 0;
}

.text a {
  color: var(--accent);
}

.list {
  display: grid;
  gap: 6px;
  margin: 0;
  padding-left: 18px;
}

.list .text {
  margin: 0;
}

@media (width <= 900px) {
  .topic {
    grid-template-columns: minmax(0, 1fr);
  }

  .toc {
    position: static;
  }
}
